import BaseApi from '@/core/HttpResources/BaseApi';
import Comentario from '@/models/comentario.model';

export default class CommentService {
    
    baseApiComment = new BaseApi("Comentario");


    async saveComment(comment: Comentario): Promise<Comentario> {
        return new Promise<Comentario>((resolve, reject) => this.baseApiComment.request('POST', String(), comment, {}, (response) => resolve(response.data), reject, () => { }))
    }

    async getComments(refEntityId:number, refEntityName:string, take=5): Promise<Array<Comentario>> {
        return new Promise<Array<Comentario>>((resolve, reject) => this.baseApiComment.request('GET', `odata/?$top=${take}&$orderby=createdDate desc&$expand=usuario($expand=persona)&$filter=refEntityName eq '${refEntityName}' and refEntityId eq ${refEntityId}`, null, {}, (response) => resolve(response.data), reject, () => { }))
    }
   
    async deleteComment(comentarioId: number): Promise<Comentario> {
        return new Promise<Comentario>((resolve, reject) => this.baseApiComment.request('DELETE', "" + comentarioId, null, {}, (response) => resolve(response.data), reject, () => { }))
    }

}